import { GroupPartyOrigin } from '../types/groupParty';
import { GO_ORIGIN } from '../types/zod/origin';

export function isExternalOrigin(origin: GroupPartyOrigin | undefined): boolean {
  return !!origin && origin !== GO_ORIGIN;
}
